import React from 'react'

const TheAside = (props) => {
  return null
}

export default React.memo(TheAside)
